import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, Controller } from 'react-hook-form'
import { Col } from 'antd'
import { RightOutlined } from '@ant-design/icons'

import { FormValidation } from './validations/validations'
import { StyledButton, StyledContainer, StyledRowMobile, StyledTitle } from '../components'
import { StyledSelect } from '../../../../../../components/StyledComponents'

type CamionProps = {
  nextStep: () => void
  prevStep: () => void
  // eslint-disable-next-line @typescript-eslint/ban-types
  control: Control<FormValidation, object>
}

const vehiculosOptions = [
  {
    label: 'Vehículo 1',
    value: 1,
  },
  {
    label: 'Vehículo 2',
    value: 2,
  },
]

export const Camion: React.FC<CamionProps> = ({ nextStep, control }) => {
  const { t } = useTranslation()

  return (
    <StyledContainer>
      <Col>
        <StyledTitle>Seleccionar Vehículo</StyledTitle>
      </Col>
      <Controller
        name="camion"
        control={control}
        render={({ field }) => (
          <StyledSelect
            {...field}
            placeholder={t('form_mobile.truck')}
            options={vehiculosOptions.map(camion => ({
              label: camion.label,
              value: camion.value,
            }))}
          />
        )}
      />
      <StyledRowMobile>
        <Col>
          <StyledButton
            style={{ backgroundColor: '#579c5f', border: 'none', color: 'white', marginTop: '5px' }}
            onClick={() => nextStep()}
          >
            Seleccionar Origen
            <RightOutlined />
          </StyledButton>
        </Col>
      </StyledRowMobile>
    </StyledContainer>
  )
}
